import { Loader } from 'semantic-ui-react';

export function Spinner({ visible, text }: { visible: boolean, text?: string }) {
  return (
    <Loader active={visible} inverted>
      {text || 'Loading'}
    </Loader>
  );
}
